import { jsx, jsxs } from "react/jsx-runtime";
import cx from "classnames";
import AspectRatioBox from "@ingka/aspect-ratio-box";
import Image from "@ingka/image";
import SSRIcon from "@ingka/ssr-icon";
import arrowRight from "@ingka/ssr-icon/paths/arrow-right";
const Card = ({
  prefix = "",
  className,
  title = "",
  label = "",
  body = "",
  ctaLabel = "",
  children,
  href,
  backgroundColor = "",
  imageProps,
  textColor = "",
  titleHeadingTag = "h2",
  emphasised = false,
  compact = false,
  imagePosition = "trailing",
  imageRatio = "wide",
  buttonVariant = "primary",
  large = false,
  ...other
}) => {
  const backgroundColorStyle = backgroundColor ? { backgroundColor } : void 0;
  const textColorStyle = textColor ? { color: textColor } : void 0;
  const cardClasses = cx(
    `${prefix}card`,
    !imageProps && `${prefix}card--without-image`,
    emphasised && `${prefix}card--emphasised`,
    large && `${prefix}card--large`,
    compact && `${prefix}card--compact`,
    imagePosition === "trailing" && `${prefix}card--trailing-image`,
    className
  );
  const cardInfoClasses = cx(`${prefix}card__info`);
  const HeadingTag = titleHeadingTag;
  const textContent = /* @__PURE__ */ jsxs("div", { className: `${prefix}card__text-wrapper`, children: [
    label && /* @__PURE__ */ jsx("span", { style: textColorStyle, className: `${prefix}card__label`, children: label }),
    title && /* @__PURE__ */ jsx(HeadingTag, { style: textColorStyle, className: `${prefix}card__title`, children: title }),
    body && /* @__PURE__ */ jsx("p", { style: textColorStyle, className: `${prefix}card__body`, children: body }),
    children
  ] });
  return /* @__PURE__ */ jsxs(
    "a",
    {
      className: cardClasses,
      href,
      style: backgroundColorStyle,
      ...other,
      children: [
        imageProps && /* @__PURE__ */ jsx("div", { className: `${prefix}card__image`, children: /* @__PURE__ */ jsx(
          AspectRatioBox,
          {
            ratio: imageRatio,
            prefix,
            className: `${prefix}card__image-aspect-ratio`,
            children: /* @__PURE__ */ jsx(Image, { prefix, ...imageProps })
          }
        ) }),
        /* @__PURE__ */ jsxs("div", { className: cardInfoClasses, children: [
          textContent,
          /* @__PURE__ */ jsx(
            "span",
            {
              style: textColorStyle,
              className: cx(
                `${prefix}card__cta`,
                ctaLabel && `${prefix}card__cta--with-button`
              ),
              children: ctaLabel || emphasised ? /* @__PURE__ */ jsx(
                "span",
                {
                  className: `${prefix}card__btn ${prefix}btn ${prefix}btn--${buttonVariant} ${prefix}btn--small`,
                  children: /* @__PURE__ */ jsxs("span", { className: `${prefix}btn__inner`, children: [
                    emphasised && buttonVariant.indexOf("icon") !== -1 && /* @__PURE__ */ jsx(
                      SSRIcon,
                      {
                        className: `${prefix}card__icon`,
                        prefix,
                        paths: arrowRight
                      }
                    ),
                    ctaLabel && /* @__PURE__ */ jsx("span", { className: `${prefix}btn__label`, children: ctaLabel })
                  ] })
                }
              ) : /* @__PURE__ */ jsx(
                SSRIcon,
                {
                  className: `${prefix}card__icon`,
                  prefix,
                  paths: arrowRight
                }
              )
            }
          )
        ] })
      ]
    }
  );
};
var Card_default = Card;
export {
  Card_default as default
};
